// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MM274","fullWidth":"Container_fullWidth__My4dr"};